import * as React from "react";
import { Unit } from "../../../models/Unit";
import { Team } from "../../../models/Team";


export interface TeamGeneratorProps {
}


export interface TeamGeneratorState {
  disallowInvalidCostCombination: boolean;
  disallowLowCostPair: boolean;

  p1: Unit | undefined;
  p2: Unit | undefined;
}


export class TeamGenerator extends React.Component<TeamGeneratorProps, TeamGeneratorState> {
  constructor(props: TeamGeneratorProps) {
    super(props);

    this.state = {
      disallowInvalidCostCombination: true,
      disallowLowCostPair: true,

      p1: undefined,
      p2: undefined,
    };
  }

  componentDidMount(): void {
  }

  shouldComponentUpdate(nextProps: Readonly<TeamGeneratorProps>, nextState: Readonly<TeamGeneratorState>, nextContext: any): boolean {
    return true;
  }

  componentWillUnmount(): void {
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
  }

  onGenerate() {
    const [p1, p2] = Team.random({
      disallowInvalidCostCombination: this.state.disallowInvalidCostCombination,
      disallowLowCostPair: this.state.disallowLowCostPair,
    });

    this.setState({
      p1,
      p2,
    });
  }

  render() {
    const p1_name = this.state.p1 ? `${this.state.p1.name}` : `----`;
    const p2_name = this.state.p2 ? `${this.state.p2.name}` : `----`;

    const p1_cost = this.state.p1 ? `${this.state.p1.cost}` : `----`;
    const p2_cost = this.state.p2 ? `${this.state.p2.cost}` : `----`;

    return (
      <>
        <form>
          <div className="form-group row">
            <div className="offset-md-2 col-md-10">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" id="allow-invalid-cost-combination"
                        checked={this.state.disallowInvalidCostCombination}
                        onChange={e => {
                          this.setState({
                            disallowInvalidCostCombination: !this.state.disallowInvalidCostCombination,
                          });
                        }}/>
                <label className="form-check-label" htmlFor="allow-invalid-cost-combination">
                  コスト割れを禁止する
                </label>
              </div>
            </div>
          </div>

          <div className="form-group row">
            <div className="offset-md-2 col-md-10">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" id="allow-invalid-const-combination"
                        checked={this.state.disallowLowCostPair}
                        onChange={e => {
                          this.setState({
                            disallowLowCostPair: !this.state.disallowLowCostPair,
                          });
                        }}/>
                <label className="form-check-label" htmlFor="allow-invalid-const-combination">
                  低コストペアを禁止する
                </label>
              </div>
            </div>
          </div>


          <div className="form-group row">
            <div className="offset-md-2 col-md-4">
              <button className="btn btn-outline-primary btn-block"
                      onClick={e => {
                        e.preventDefault();

                        this.onGenerate();
                      }}>
                生成
              </button>
            </div>

            <div className="col-md-4">
              <button className="btn btn-outline-primary btn-block">
                クリア
              </button>
            </div>
          </div>
        </form>


        <h3>
          結果
        </h3>

        <form>
          <div className="form-group row">
            <label htmlFor="p1_name" className="col-md-2 col-form-label">
              P1
            </label>
            <div className="col-md-6">
              <input type="text" readOnly className="form-control-plaintext" id="p1_name" value={p1_name}/>
            </div>
            <div className="col-md-4">
              <input type="text" readOnly className="form-control-plaintext" id="p1_cost" value={p1_cost}/>
            </div>
          </div>

          <div className="form-group row">
            <label htmlFor="p2_name" className="col-md-2 col-form-label">
              P2
            </label>
            <div className="col-md-6">
              <input type="text" readOnly className="form-control-plaintext" id="p2_name" value={p2_name}/>
            </div>
            <div className="col-md-4">
              <input type="text" readOnly className="form-control-plaintext" id="p2_cost" value={p2_cost}/>
            </div>
          </div>
        </form>
      </>
    );
  }
}
